import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const year = new Date().getFullYear();

  // In-page anchors are written as "/#id", not "#id", because this footer also
  // renders on /privacy and /terms — where a bare "#id" would point at an
  // anchor that doesn't exist on the page and do nothing. "/#id" scrolls when
  // already on the home page and navigates home when not.
  return (
    <footer>
      <div className="wrap">
        <div className="foot-top">
          <div className="foot-brand">
            <a href="/#top" className="brand">
              <span className="glyph">OS</span> OgaStock
            </a>
            <p>Tools for Africa's building-materials traders. One13 is our first product.</p>
          </div>
          <div className="foot-cols">
            <div className="foot-col">
              <h4>Product</h4>
              <a href="/#product">One13</a>
              <a href="/#how">How it works</a>
              <a href="/#pricing">Pricing</a>
            </div>
            <div className="foot-col">
              <h4>Company</h4>
              <a href="/#vision">Vision</a>
              <a href="/#contact">Contact</a>
            </div>
            <div className="foot-col">
              <h4>Legal</h4>
              <Link to="/privacy">Privacy Policy</Link>
              <Link to="/terms">Terms of Service</Link>
            </div>
          </div>
        </div>
        <div className="foot-bottom">
          <span>© {year} OgaStock. All rights reserved.</span>
          <span>Made in Nigeria · for the trade</span>
        </div>
      </div>
    </footer>
  );
}
